//borderColor: (theme) => console.log(theme),
const keyNames = {
  REUSABLE: "REUSABLE",
  apiErrors: "apiErrors",
  themeMode: "themeMode",
  apiMsg: "apiMsg",
  extra: "extra",
  isLoading: "isLoading",
  toastData: "toastData",
  isAuthenticated: "isAuthenticated",
  //End multiple
  forceLogOut: "forceLogOut",
  userData: "userData",
  registeredUserData: "registeredUserData",
  widgetData: "widgetData",
  folderList: "folderList",
  fileList: "fileList",
  dashboardStats: "dashboardStats",
  dashboardFolders: "dashboardFolders",
  dashboardUploads: "dashboardUploads",
  dashboardActivity: "dashboardActivity",
  dashboardChart: "dashboardChart",
};
export default keyNames;
